import { createFileRoute, redirect } from '@tanstack/react-router';

// 旧インバウンドSSOのハッシュリンクは設定 > 認証の SSO へ寄せる。
// 認証ポリシー本体はこの画面でも操作できる（共有コンポーネント）。
export const Route = createFileRoute('/_staff/settings/persons/_list/settings/')({
  beforeLoad: ({
    location
  }) => {
    const hash = location.hash.replace(/^#/, '');
    if (hash === 'sso') {
      throw redirect({
        to: '/settings/authentication/settings/sso'
      });
    }
  }
});